<template>
  <div class="" v-if="comment_dialog">
    <v-container fluid class="px-4 mt-n4">
      <v-card elevation="0">
        <v-alert outlined color="grey lighten-3" class="rounded-1 px-0 py-0">
          <v-card-title style="color: black" class="my-n2 mx-n2">
            <v-icon small color="black">mdi-message-text-outline</v-icon>
            <span class="body-2 ml-2">Comments</span>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-on="on"
                  v-bind="attrs"
                  @click="closeComments"
                  class="grey--text add-pointer"
                  >&times;</span
                >
              </template>
              <span>Close comments</span>
            </v-tooltip>
          </v-card-title>
          <v-card-text
            v-if="comments.length > 0"
            style="max-height: 230px; overflow: auto"
          >
            <v-list two-line>
              <template v-for="comment in comments[0].rows">
                <v-list-item :key="comment.id">
                  <v-list-item-avatar>
                    <v-avatar color="indigo lighten-1" size="46">
                      <span class="white--text body-1">
                        {{
                          comment.user.first_name.charAt(0) +
                          comment.user.last_name.charAt(0)
                        }}
                      </span>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-row class="mt-n3">
                        <v-col cols="6">
                          <span class="indigo--text body-2 font-weight-bold">
                            {{ comment.user.first_name }}
                            {{ comment.user.last_name }}
                            <v-spacer></v-spacer>
                          </span>
                        </v-col>
                        <v-col cols="6" class="text-right">
                          <div class="body-2 grey--text">
                            {{ comment.date }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="mt-n2"
                      v-html="comment.msg"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <div :key="comment.msg" class="pr-5">
                  <v-divider :key="comment.date" :inset="true"></v-divider>
                </div>
              </template>
            </v-list>
          </v-card-text>
          <v-card-text class="text-right mt-n10">
            <v-btn
              elevation="0"
              class="body-2 load-more text-lowercase"
              depressed
              color="purple"
              small
              text
              rounded
              @click="loadMoreComments"
              v-if="more_comments"
            >
              Load more comments...
            </v-btn>
          </v-card-text>
          <v-card-text>
            <v-container class="px-0 py-0 mt-n4 mb-n4 mx-0 black--text">
              <AddCommentModal
                :dialog="comment_dialog"
                :routeId="routeId"
                :routeType="routeType"
                :accessRoute="accessRoute"
                :items="getUserTaggings"
                @closeDialog="close"
                @addedComment="addComment"
              />
            </v-container>
          </v-card-text>
        </v-alert>
      </v-card>
    </v-container>
    <!-- <v-container class="mb-n6" >
      <v-row>
        <v-col class="d-flex justify-space-between">
          <p class="my-0 ml-10 text-uppercase font-weight-regular caption indigo--text">
            Add Comment
            <v-btn
              fab
              x-small
              depressed
              light
              @click="add_comment_dialog = true"
            >
              <v-icon> mdi-message-plus </v-icon>
            </v-btn>
          </p>
          <v-spacer></v-spacer>
          <span
            class="mt-2 subtitle-2 indigo--text load-more mr-10"
            @click="closeComments"
          >
            Close Comments
          </span>
        </v-col>
      </v-row>
    </v-container> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AddCommentModal from "../sub_routes/AddCommentModal";

export default {
  name: "RouteComments",
  props: {
    comment_dialog: Boolean,
    routeId: Number,
    accessRoute: Number,
    routeType: String,
  },
  components: {
    AddCommentModal,
  },
  data() {
    return {
      more_comments: false,
      add_comment_dialog: false,
      comments: [],
      page: null,
      limit: 5,
      initiator_route: this.routeId,
      taggingUsers: [],
    };
  },
  methods: {
    ...mapActions([
      "openRouteComments",
      "fetchMoreComments",
      "fetchUserTaggings",
    ]),
    addComment() {},
    loadMoreComments() {
      this.page = this.page != null ? this.page + 1 : 1;
      const body = {
        route_id: this.initiator_route,
        assigned_route_id: this.routeId,
        type: "mainroute",
        page: this.page,
      };
      this.fetchMoreComments(body)
        .then((res) => {
          if (res) {
            this.comments = this.getRouteComments;

            if (this.comments[0].count > this.comments[0].rows.length)
              this.more_comments = true;
            else this.more_comments = false;
          } else {
            console.log("res: ", res);
          }
        })
        .catch((err) => console.log(err));
    },
    close() {
      this.add_comment_dialog = false;
    },
    closeComments() {
      this.$emit("closeComments", this.routeId);
    },
    // scroll() {
    //   window.onscroll = () => {
    //     let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight

    //     if (bottomOfWindow) {
    //       alert('yow'); // replace it with your code
    //     }
    //   }
    // }
  },
  // mounted () {
  //   this.scroll()
  // },
  computed: {
    ...mapGetters(["getRouteComments", "getUserTaggings"]),
  },
  watch: {
    comment_dialog: function () {
      if (this.comment_dialog) {
        let body = {
          route_id: this.initiator_route,
          assigned_route_id: this.routeId,
          type: "mainroute",
        };

        this.openRouteComments(body).then(() => {
          // this.comments = this.getOpenedComments.filter(comment => comment.assigned_route_id == this.routeId && comment.type == this.routeType);
          this.comments = this.getRouteComments;
          if (this.comments[0].count > this.comments[0].rows.length)
            this.more_comments = true;
          else this.more_comments = false;
        });
      }
    },
  },
  created() {
    this.fetchUserTaggings();
  },
};
</script>

<style scoped>
.add-pointer {
  cursor: pointer;
}

.load-more {
  cursor: pointer;
}

.multi-line {
  white-space: pre-line;
}

.mention {
  color: red;
}
</style>
